import React from "react";
import EmployeeTransfersGenericSkeleton from "./EmployeeTransfersGenericSkeleton";

function EmployeeTransfersDetailSkeleton() {
  return (
    <>
      <EmployeeTransfersGenericSkeleton />
    </>
  );
}

export default EmployeeTransfersDetailSkeleton;
